import { Routes, Route } from 'react-router-dom';
import { RequireAuth } from '@beatq/shared';
import { AppRoutes } from './routes/screenRoutes.js';

export function App() {
  return (
    <Routes>
      <Route element={<RequireAuth surface="merchant" />}>
        <Route path="/*" element={<AppRoutes />} />
      </Route>
    </Routes>
  );
}
